module.exports = __webpack_public_path__ + "static/media/415JamesPBrawleyDrNW_2018-06-12_81.85662055.jpg";